import { createSelector } from '../reselect';
import {
  getNewStatsService,
  total,
  simpleChart,
  simpleChart2,
  simpleChart3,
  safeDivide,
} from '../generalUtils';

const getNewStats = getNewStatsService('pinterest-ads');

// Pinterest start
const pinterestSpend = createSelector([getNewStats], (stats) => {
  return total(stats, 'spend');
});

const pinterestSpendChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'spend');
});

const pinterestTotalClicks = createSelector([getNewStats], (stats) => {
  return total(stats, 'clicks');
});

const pinterestTotalClicksChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'clicks');
});

const pinterestConversionValue = createSelector([getNewStats], (stats) => {
  return total(stats, 'conversionValue');
});

const pinterestConversionValueChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'conversionValue');
});

const pinterestImpressions_1 = createSelector([getNewStats], (stats) => {
  return 0;
});

const pinterestImpressions_2 = createSelector([getNewStats], (stats) => {
  return 0;
});

const pinterestImpressions_1Chart = createSelector([getNewStats], (stats) =>
  simpleChart(stats, 'pinterest_IMPRESSION_1')
);

const pinterestImpressions_2Chart = createSelector([getNewStats], (stats) =>
  simpleChart(stats, 'pinterest_IMPRESSION_2')
);

const pinterestImpressions = createSelector(
  [pinterestImpressions_1, pinterestImpressions_2, getNewStats],
  (impressions_1, impressions_2, stats) => {
    return total(stats, 'impressions');
  }
);

const pinterestImpressionsChart = createSelector(
  [pinterestImpressions_1Chart, pinterestImpressions_2Chart, getNewStats],
  (impressions_1, impressions_2, stats) => {
    return simpleChart(stats, 'impressions');
  }
);

const pinterestPurchases = createSelector([getNewStats], (stats) => {
  return total(stats, 'purchases');
});

const pinterestPurchasesChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'purchases');
});

const pinterestRoas = createSelector(
  [pinterestConversionValue, pinterestSpend],
  (conversionValue, spend) => safeDivide(conversionValue, spend)
);

const pinterestRoasChart = createSelector(
  [pinterestConversionValueChart, pinterestSpendChart],
  (conversionValue, spend) => simpleChart2(conversionValue, spend, { chart1yMultiplier: 1 })
);

const pinterestCpc = createSelector([pinterestTotalClicks, pinterestSpend], (clicks, spend) =>
  safeDivide(spend, clicks)
);

const pinterestCpcChart = createSelector(
  [pinterestTotalClicksChart, pinterestSpendChart],
  (clicks, spend) => simpleChart2(spend, clicks, { chart1yMultiplier: 1 })
);

const pinterestCpm = createSelector([pinterestImpressions, pinterestSpend], (impressions, spend) =>
  safeDivide(spend, impressions / 1000)
);

const pinterestCpmChart = createSelector(
  [pinterestImpressionsChart, pinterestSpendChart],
  (impressions, spend) => {
    return simpleChart2(spend, impressions, { chart1yMultiplier: 1000 });
  }
);

const pinterestCtr = createSelector(
  [pinterestImpressions, pinterestTotalClicks],
  (impressions, clicks) => safeDivide(clicks, impressions) * 100
);

const pinterestCtrChart = createSelector(
  [pinterestImpressionsChart, pinterestTotalClicksChart],
  (impressions, clicks) => simpleChart2(clicks, impressions, { chart1yMultiplier: 100 })
);

const pinterestCpa = createSelector([pinterestPurchases, pinterestSpend], (purchases, spend) =>
  safeDivide(spend, purchases)
);

const pinterestCpaChart = createSelector(
  [pinterestPurchasesChart, pinterestSpendChart],
  (purchases, spend) => simpleChart2(spend, purchases, { chart1yMultiplier: 1 })
);
// Pinterest end

// MAINLY FOR updateDayStats
const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    pinterestSpend,
    pinterestSpendChart,
    pinterestTotalClicks,
    pinterestTotalClicksChart,
    pinterestConversionValue,
    pinterestConversionValueChart,
    pinterestImpressions,
    pinterestImpressions_1,
    pinterestImpressions_2,
    pinterestImpressionsChart,
    pinterestPurchases,
    pinterestPurchasesChart,
    pinterestRoas,
    pinterestRoasChart,
    pinterestCpc,
    pinterestCpcChart,
    pinterestCpm,
    pinterestCpmChart,
    pinterestCtr,
    pinterestCtrChart,
    pinterestCpa,
    pinterestCpaChart,
  },
};
